import { isShopGidOptionalForPrsFlow } from './journey'

enum AppointmentParameters {
  APPOINTMENT_TYPE = 'appointment_type',
  COUNTRY = 'country',
  CUSTOMER_GID = 'customer_gid',
  DURATION_IN_MINUTES = 'duration_in_minutes',
  JOURNEY = 'journey',
  OPPORTUNITY_GID = 'opportunity_gid',
  RESOURCE_ID = 'resource_id',
  SHOP_GID = 'shop_gid',
}

const getRequiredAppointmentParameters = (journey?: string, country?: string): AppointmentParameters[] => [
  AppointmentParameters.CUSTOMER_GID,
  AppointmentParameters.JOURNEY,
  AppointmentParameters.OPPORTUNITY_GID,
  ...(!isShopGidOptionalForPrsFlow(journey, country) ? [AppointmentParameters.SHOP_GID] : []),
]

export { AppointmentParameters, getRequiredAppointmentParameters }
